(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quote-font-controls"] && !Shopify.designMode) return;
  try {
    class QuoteFontPicker extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const section = this.closest('.shopify-section');
      section?.addEventListener('shopify:product:select', (event) => this.handleProductSelect(event), {
        signal: this.abortController.signal,
      });
      this.productForm = document.getElementById(this.dataset.productFormId);
      this.refreshControls();
      this.restoreSelection();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.radioAbortController?.abort();
    }

    refreshControls() {
      this.radioAbortController?.abort();
      this.radioAbortController = new AbortController();
      this.hiddenInput = this.querySelector('[data-quote-font-visible-property]');
      this.radios = [...this.querySelectorAll('input[name="properties[_pnp_quote_font_style]"]')];
      this.radios.forEach((radio) => radio.addEventListener('change', (event) => {
        // Font is a line-item property, not a Shopify variant option. Keep its
        // change event away from Horizon's variant-picker morph lifecycle.
        event.stopPropagation();
        this.selectFont(radio);
      }, { signal: this.radioAbortController.signal }));
    }

    restoreSelection() {
      const storedStyle = this.productForm?.dataset.pnpQuoteFontStyle;
      const selectedStyle = storedStyle || this.dataset.defaultFontStyle;
      const selectedRadio = this.radios?.find((radio) => radio.value === selectedStyle);
      if (selectedRadio) selectedRadio.checked = true;
      this.sync();
    }

    handleProductSelect(event) {
      if (!(event.promise instanceof Promise)) return;
      event.promise
        .then(() => requestAnimationFrame(() => {
          this.refreshControls();
          this.restoreSelection();
        }))
        .catch(() => {});
    }

    sync() {
      const selected = this.radios?.find((radio) => radio.checked);
      if (selected && this.hiddenInput) this.hiddenInput.value = selected.dataset.label || selected.value;
      this.dispatchEvent(new CustomEvent('quote:preview-change', { bubbles: true }));
    }

    selectFont(radio) {
      if (this.productForm) this.productForm.dataset.pnpQuoteFontStyle = radio.value;
      this.sync();
    }
  }

  if (!customElements.get('quote-font-picker')) {
    customElements.define('quote-font-picker', QuoteFontPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
